import { render, staticRenderFns } from "./ObservacionesCita.vue?vue&type=template&id=111b40bd&scoped=true"
import script from "./ObservacionesCita.vue?vue&type=script&lang=js"
export * from "./ObservacionesCita.vue?vue&type=script&lang=js"
import style0 from "./ObservacionesCita.vue?vue&type=style&index=0&id=111b40bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111b40bd",
  null
  
)

export default component.exports